<template>
  <div class="code-edit-modal">
    <base-modal
      ref="modal"
      size="auto"
      title="Code Edit"
      @submit="saveModal"
    >
      <template #content>
        <code-editor
          v-model="code"
          height="300px"
          :line-nums="true"
          @textarea="focus"
        />
      </template>
      <template #actions>
        <base-button
          size="xl"
          @click.prevent="modal.close"
        >
          {{ cancelButton }}
        </base-button>
        <primary-button
          :disabled="processing"
          size="xl"
          @click="saveModal"
        >
          {{ actionButton }}
        </primary-button>
      </template>
    </base-modal>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: String,
      default: "Cancel"
    },
    cancelButton: {
      type: String,
      default: "Cancel"
    },
    actionButton: {
      type: String,
      default: "Save"
    },
    success: {
      type: Function,
      default: () => {
      }
    }
  },
  data () {
    return {
      modal: {
        close: () => {
        }
      },
      code: "",
      processing: false
    }
  },
  mounted () {
    this.modal = this.$refs.modal
    this.code = this.value
  },
  methods: {
    saveModal (event) {
      if (this.success) {
        this.success(this.code)
      }
      // only close by clicking on the button
      if (event) {
        this.modal.close()
      }
    },
    focus (node) {
      node.focus()
    }
  }
}
</script>

<style scoped>
</style>
